export enum UsageOfResidence {
    ResidentialCustomer = 'residentialCustomer',
    ProfessionalCustomer = 'professionalCustomer',
    SecondResidence = 'secondResidence',
    Vacancy = 'vacancy',
}
